// This file is auto-generated don't edit it!
import { Component } from '@angular/core';

@Component({
    selector: 'ui-radio-docs',
    templateUrl: './radio.docs.generated.html',
})
export class UIRadioDocs { }
